export default __webpack_public_path__ + "static/media/keg.27725793.png";